import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import {SlideDown} from 'react-slidedown'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  VanguardCompanyLetter,
  PetitionForm,
} from '../../components'
import Styles from './AmazonVanguardLanding.css'


@CSSModules(Styles, {allowMultiple:true})
export default class AmazonVanguardLanding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Save for your future without ruining theirs',
      description: 'Vanguard’s default 401(k) option for Amazon employees is investing hundreds of millions of dollars into agribusiness companies that are devastating our rainforests.',
      url: config.domain + config.routes.amazonVanguardLanding,
      mobileBannerFixed: true,
      showLetter: false,
      showFullPetition: false
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  render() {
    const { title, description, url } = this.state

    const headlineImg = require('../../../static/images/monkeys-circle.jpg')

    const mobileBannerStyle = this.state.mobileBannerFixed ?
      'mobile-fixed' :
      'mobile-relative'

    return (
      <div styleName='page'>
        {
          container.helmet(
            title,
            description,
            url
          )
        }
        <ContainerDivs>

          <div styleName='hl-wrap'>
            { /* LEFT COLUMN */ }
            <div>
              <div styleName='hl'>
                {title}
              </div>
              <img
                src={headlineImg}
                alt='Save for your future without ruining theirs'
                styleName='hl-img-sm visible-xs'
              />
              <div styleName='copy'>
                <p>
                  Every year, the world loses an area of tropical rainforest the size of the United Kingdom.
                </p>
                <p>
                  Massive deforestation to clear land for palm oil, pulp and paper, soy, rubber, timber, and cattle is also responsible for almost one quarter of all global greenhouse gas emissions. Corporate control of land used for industrial plantation agriculture is also a leading cause of violent land conflicts, as these activities dispossess and displace local indigenous communities.
                </p>

                <p>
                  What most Amazon employees don’t know is that the Vanguard funds in their 401(k) have millions of dollars invested into agribusiness companies that are devastating our rainforests. Vanguard’s continued financing of the world’s worst deforestation companies exposes its investors, like those in the Amazon 401(k), to reputational and financial risk.
                </p>
                <p styleName='scroll-link'>
                  <ScrollLink
                    activeClass='active-scroll-link'
                    to='section1'
                    spy
                    smooth
                    offset={-70}
                    duration={500}
                  >
                    <b>Urge Vanguard to offer sustainable target date funds that can be the default 401(k) option for Amazon employees.</b>
                  </ScrollLink>
                </p>

                <div styleName='hidden-xs'>
                  <p>
                    Most Amazon employees have no idea Vanguard is using their retirement savings to funnel money into agribusiness companies like JBS and Bunge, which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.
                  </p>
                  <p>
                    Large fund managers like Vanguard can move the entire market and play a crucial role in averting catastrophe, and could instead finance the transition to a livable planet. But, unfortunately, they won’t do it without pressure from us.
                  </p>

                  <p styleName='scroll-link'>
                    <ScrollLink
                      activeClass='active-scroll-link'
                      to='section1'
                      spy
                      smooth
                      offset={-70}
                      duration={500}
                    >
                      <b>Urge Vanguard to offer sustainable target date funds to Amazon employees!</b>
                    </ScrollLink>
                  </p>

                  { /* PETITION LETTER */ }
                  <VanguardCompanyLetter/>
                </div>

                { /* AFTER PETITION LINKS */ }
                <div styleName='after-petition-links hidden-xs'>
                  <div styleName='after-petition-links-lbl'>
                    More
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.plans + '/amazon-com'}
                      title='Amazon 401(k) scorecard'
                      xstrong
                    >
                      See the scorecard for the Amazon 401(k)<LinkIcon/>
                    </Link>
                  </div>
                  <div styleName='after-petition-links-div'>
                    <Link
                      to={config.routes.eduCenter}
                      title='Action center'
                      xstrong
                    >
                      Action center<LinkIcon/>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            { /* RIGHT COLUMN */ }
            <div styleName='hl-img-wrap'>
              <div styleName='petition-widget-wrap'>
                <img
                  src={headlineImg}
                  alt='Save for your future without ruining theirs'
                  styleName='hl-img hidden-xs'
                />
                <div styleName={'sticky-widget ' + mobileBannerStyle}>
                  <div id='section1'/>
                  <div styleName='sticky-widget-close visible-xs'>
                    <div
                      onClick={
                        () => {
                          //
                          this.setState({
                            mobileBannerFixed: false
                          })
                        }
                      }
                    >
                      <LinkIcon nospace faclass='fa-close'/>
                    </div>
                  </div>
                  <h2 styleName='thumbs-up-top-label'>
                    Vanguard: Offer Amazon Employees Sustainable Target Date Funds!
                  </h2>
                  <div styleName='c'>
                    <h3 styleName='thumbs-up-top-label-2'>
                      Sign this petition
                    </h3>
                  </div>
                  <PetitionForm
                    petitionConfig={config.petitionConfigs.amazonVanguard}
                  />
                </div>
              </div>
            </div>
          </div>

          <div styleName='visible-xs'>
            <div
              styleName='show-more-button'
              title='Learn more'
              onClick={
                (e)=>{
                  this.setState({showFullPetition: !this.state.showFullPetition})
                }
              }
            >
              Learn more<LinkIcon faclass={
                this.state.showFullPetition ?
                  'fa-angle-double-up' :
                  'fa-angle-double-down'
              }/>
            </div>
            <SlideDown>
              {
                this.state.showFullPetition ?
                  (
                    <div styleName='copy'>
                      <p>
                        Most Amazon employees have no idea Vanguard is using their retirement savings to funnel money into agribusiness companies like JBS and Bunge, which source from farms that have been fined for illegal deforestation and slave labor practices in the Brazilian Amazon.
                      </p>
                      <p>
                        Large fund managers like Vanguard can move the entire market and play a crucial role in averting catastrophe, and could instead finance the transition to a livable planet. But, unfortunately, they won’t do it without pressure from us.
                      </p>

                      <p styleName='scroll-link'>
                        <ScrollLink
                          activeClass='active-scroll-link'
                          to='section1'
                          spy
                          smooth
                          offset={-70}
                          duration={500}
                        >
                          <b>Urge Vanguard to offer sustainable target date funds to Amazon employees!</b>
                        </ScrollLink>
                      </p>

                      { /* PETITION LETTER */ }
                      <VanguardCompanyLetter/>
                    </div>
                  ) :
                  null
              }
            </SlideDown>
          </div>

          { /* AFTER PETITION LINKS */ }
          <div styleName='after-petition-links visible-xs'>
            <div styleName='after-petition-links-lbl'>
              More
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.plans + '/amazon-com'}
                title='Amazon 401(k) scorecard'
                xstrong
              >
                See the scorecard for the Amazon 401(k)<LinkIcon/>
              </Link>
            </div>
            <div styleName='after-petition-links-div'>
              <Link
                to={config.routes.eduCenter}
                title='Action center'
                xstrong
              >
                Action center<LinkIcon/>
              </Link>
            </div>
          </div>

        </ContainerDivs>
      </div>
    )
  }
}
